import React from 'react';
import Badge from '../../common2/Badge';
import { ConsumerActionStatus } from '../../../api/types';

const consumerActionStatusTitleIntent = {
  [ConsumerActionStatus.PENDING]: {
    intent: 'warning',
    title: 'Pending',
  },
  [ConsumerActionStatus.COMPLETED]: {
    intent: 'positive',
    title: 'Completed',
  },
  [ConsumerActionStatus.REJECTED]: {
    intent: 'alert',
    title: 'Rejected',
  },
  [ConsumerActionStatus.EXPIRED]: {
    intent: 'alert',
    title: 'Expired',
  },
};

function ConsumerActionStatusBadge({ consumerActionStatus }: { consumerActionStatus: ConsumerActionStatus | null }) {
  if (!consumerActionStatus) {
    return null;
  }

  const consumerActionStatusBadgeData = consumerActionStatusTitleIntent[consumerActionStatus];
  return <Badge intent={consumerActionStatusBadgeData.intent}>{consumerActionStatusBadgeData.title}</Badge>;
}

export default React.memo(ConsumerActionStatusBadge);
